<template>
  <HomeContainer :title="$t('title.howToRun5Steps')">
    <b-steps :animated="true" :has-navigation="true" size="is-medium">
      <b-step-item
        label="Profil Oluştur"
        icon="project-diagram"
        :clickable="true"
        :type="{ 'is-danger': true }"
      >
        <div class="columns is-centered">
          <div class="column is-11">
            <div class="content">
              <p>
                <b>Onlineicdenetim.com</b> ürününü kullanmak kendi kendinize operasyonlarınızı
                denetlemek çok kolay, hızlı ve kullanıcı dostudur.
              </p>
              <p>
                5 Soruda kullanıcı hesabınızı yaratın, size özel bir şifre belirleyip anında
                onlineicdenetim.com sitesini kullanmaya başlayabilirsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-step-item>
      <b-step-item
        label="Süreç Seçimi"
        :clickable="true"
        icon="search"
        :type="{ 'is-danger': true }"
      >
        <div class="columns is-centered">
          <div class="column is-11">
            <div class="content">
              <p>
                Sizler için hazırladığımız iç denetim uygulamalarından istediğinizi seçebilirsiniz.
              </p>
              <p>
                Mevcut iç denetim uygulamalarını görmek için “Süreç Kataloğu” sayfamızı ziyaret
                edebilirsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-step-item>
      <b-step-item
        label="Ön Hazırlık"
        :clickable="true"
        icon="question"
        :type="{ 'is-danger': true }"
      >
        <div class="columns is-centered">
          <div class="column is-11">
            <div class="content">
              <p>
                Seçtiğiniz iç denetim uygulamasını cevaplamaya geçmeden önce ““Ön Hazırlık””
                bölümünü lütfen okuyun.
              </p>

              <p>Bu bölümde, iç denetim uygulaması için;</p>
              <ul>
                <li>Bizim önerdiğimiz “katılımcılar” listesini,</li>
                <li>Denetim için gerekli yaklaşık zamanı, içeren bilgileri bulacaksınız.</li>
              </ul>
            </div>
          </div>
        </div>
      </b-step-item>

      <b-step-item
        label="Cevaplama"
        :clickable="true"
        icon="chart-pie"
        :type="{ 'is-danger': true }"
      >
        <div class="columns is-centered">
          <div class="column is-11">
            <div class="content">
              <p>Tüm sorular “EVET” / “HAYIR” seçeneklerinden birisi tercih edilerek cevaplanır.</p>

              <p>
                Tüm soruların cevaplanması mecburi olup, emin olmadığınız veya kurumunuzda
                uygulaması bulunmayan sorular “HAYIR” seçeneği ile cevaplanmalıdır.
              </p>
              <p>
                Cevapların gerçekçi verilmesi iç denetim skorlamasının ve denetim raporunun sağlıklı
                olması açısından önemlidir.
              </p>
            </div>
          </div>
        </div>
      </b-step-item>
      <b-step-item label="Raporlama" :clickable="true" icon="poll" :type="{ 'is-danger': true }">
        <div class="columns is-centered">
          <div class="column is-11">
            <div class="content">
              <p>Cevapladığınız her denetim anında değerlendirilir, skorlanır ve raporlanır.</p>
              <p>İç denetim raporunuz aşağıdaki başlıklardan oluşmaktadır:</p>
              <ul>
                <li>Genel değerlendirme</li>
                <li>Süreç skor panosu ve skor grafikleri / gelişim grafikleri</li>
                <li>Skor panosu detaylı değerlendirmesi</li>
                <li>Öne Çıkan İç Kontrol Eksiklikleri</li>
                <li>Öneriler</li>
              </ul>
              <p>
                Denetim sonucu alacağınız iç kontrol skorlarınız aşağıdaki başlıklar altında
                hesaplanır:
              </p>
              <ul>
                <li>COSO iç kontrol ana başlıkları için yeterlilik skorlarınız (1)</li>
                <li>İç kontrol başlıklarının ağırlıklı ortalaması olarak Neta Skorunuz</li>
                <li>COSO iç kontrol bileşenleri kırılımında yeterlilik skorlarınız (2)</li>
              </ul>
              <div class="content" style="padding-left:40px;">
                <p>
                  <b>(1) COSO iç kontrol ana başlıkları</b>
                </p>
                <ul>
                  <li>Finansal Raporlama Güvenilirliği,</li>
                  <li>Yasa ve Kanunlar ile Uyum,</li>
                  <li>Operasyonlarda Etkinlik ve Verimlilik,</li>
                  <li>
                    Suistimal Önleyici Kontrollerin Varlığı (Neta Denetim değerlendirmesidir).
                  </li>
                </ul>
                <p>
                  <b>(2) COSO iç kontrol bileşenleri</b>
                </p>
                <ul>
                  <li>Kontrol Ortamı Yaratılması,</li>
                  <li>Risk Değerlemesi Yapılması,</li>
                  <li>Kontrol Aktivitelerinin Kurgulanması,</li>
                  <li>Bilgi ve İletişimin Etkin Kullanılması,</li>
                  <li>Gözetim ve İzleme Yapılması.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-step-item>
      <template slot="navigation" slot-scope="{ previous, next }">
        <div class="columns is-centered" style="padding-top:30px;">
          <b-button
            icon-pack="fas"
            icon-left="chevron-left"
            :disabled="previous.disabled"
            @click.prevent="previous.action"
            >{{ $t('button.previous') }}</b-button
          >
          <b-button
            icon-pack="fas"
            icon-right="chevron-right"
            :disabled="next.disabled"
            @click.prevent="next.action"
            >{{ $t('button.next') }}</b-button
          >
        </div>
      </template>
    </b-steps>
  </HomeContainer>
</template>

<script>
export default {}
</script>
